// extracted by mini-css-extract-plugin
module.exports = {"container":"SrcSet_container__V6RhK","image":"SrcSet_image__eFbvk"};